import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "@/assets/EMA-KO-Logo.png";

const scrollTo = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const location = useLocation();
  const isHomepage = location.pathname === "/";
  const [open, setOpen] = useState(false);

  const navLinks = (
    <>
      <Link to="/video-portfolio" onClick={() => setOpen(false)} className="text-section-dark-foreground hover:text-cta-blue transition text-base font-semibold">
        Video Portfolio
      </Link>
      <Link to="/product-photos" onClick={() => setOpen(false)} className="text-section-dark-foreground hover:text-cta-blue transition text-base font-semibold">
        Photo Portfolio
      </Link>
      <Link to="/ai" onClick={() => setOpen(false)} className="text-section-dark-foreground hover:text-cta-blue transition text-base font-semibold">
        AI Shoot
      </Link>
      <Link to="/content" onClick={() => setOpen(false)} className="text-section-dark-foreground hover:text-cta-blue transition text-base font-semibold">
        Content
      </Link>
      <Link to="/blog" onClick={() => setOpen(false)} className="text-section-dark-foreground hover:text-cta-blue transition text-base font-semibold">
        Blog
      </Link>
      <a href="https://evolvemedia.agency/pricing" onClick={() => setOpen(false)} className="text-section-dark-foreground hover:text-cta-blue transition text-base font-semibold">
        Pricing
      </a>
      <a href="https://calendly.com/evolvemedia/amz-30-min" target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="text-section-dark-foreground hover:text-cta-blue transition text-base font-semibold">
        Contact
      </a>
    </>
  );

  return (
    <nav className="sticky top-0 z-50 bg-black border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to="/">
          <img src={logo} alt="Evolve Media Agency" className="h-8" />
        </Link>

        {/* Desktop nav */}
        <div className="hidden lg:flex gap-8 mr-4">
          {navLinks}
        </div>

        {/* Mobile/tablet hamburger */}
        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white bg-transparent border-none cursor-pointer p-1"
          aria-label="Toggle menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile/tablet dropdown */}
      {open && (
        <div className="lg:hidden bg-black border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          {navLinks}
        </div>
      )}
    </nav>
  );
}
